import "./App.css";
import { useMemo } from "react";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSlopeWallet,
  getSolflareWallet,
  getSolletExtensionWallet,
  getSolletWallet,
} from "@solana/wallet-adapter-wallets";
import nftsGif from "./assets/nfts-min.gif";

import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";

import { createTheme, ThemeProvider } from "@material-ui/core";
import Logo from "./Logo";
import Background from "./Background";

const theme = createTheme({
  palette: {
    type: "dark",
  },
});

const network = (process.env.REACT_APP_SOLANA_NETWORK ??
  "devnet") as WalletAdapterNetwork;

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSolflareWallet(),
      getSlopeWallet(),
      getSolletWallet({ network }),
      getSolletExtensionWallet({ network }),
    ],
    []
  );

  return (
    <ThemeProvider theme={theme}>
      <ConnectionProvider endpoint={endpoint}>
        <WalletProvider wallets={wallets} autoConnect>
          <WalletDialogProvider>
            <Background />
            <Logo />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "125px",
                  padding: "14px",
                  width: "448px",
                  height: "582px",
                  backgroundColor: "#0f101a",
                  borderRadius: "16px",
                  boxShadow: "-3px 6px 11px 0px black",
                }}
              >
                <img
                  src={nftsGif}
                  width={400}
                  height={400}
                  style={{
                    borderTopLeftRadius: "18px",
                    borderTopRightRadius: "18px",
                    marginBottom: "14px",
                  }}
                />
                <h1
                  style={{
                    color: "white",
                    fontFamily: "Roboto",
                    fontSize: "3rem",
                    marginBottom: "0",
                    marginTop: "14px",
                  }}
                >
                  Mint is over
                </h1>
              </div>
            </div>
          </WalletDialogProvider>
        </WalletProvider>
      </ConnectionProvider>
    </ThemeProvider>
  );
};

export default App;
